import { Kaart } from '@/components/map/Kaart';
import { FormulierPaneel } from '@/components/form/FormulierPaneel';

/** Hoofdscherm: fullscreen kaart met het registratieformulier ernaast/eronder. */
export function KaartPagina(): JSX.Element {
  return (
    <>
      <Kaart />
      <FormulierPaneel />
    </>
  );
}
